module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_StrokeCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_StrokeCity.png
// module id = 2090
// module chunks = 4